import React, { Dispatch, SetStateAction, useReducer, useState, ChangeEvent, useRef, useEffect, KeyboardEvent } from 'react';
import { Popover, Form, Button, Table, OverlayTrigger, Modal, Overlay, Alert, FormControl } from 'react-bootstrap';
import Select from "react-select"
import { AppState } from 'src/store';
import { connect } from 'react-redux';
import Axios from 'axios';
import AxiosConfig from '../../../../utilities/AxiosConfig';
import './PTOPlanMaintenance.css';
import PTOPlanMaintenanceWarnLostChanges from './PTOPlanMaintenanceWarnLostChanges/PTOPlanMaintenanceWarnLostChanges';
import reggie from 'src/utilities/Reggie';


interface IProps {
    showModal: boolean;
    setShowModal: Dispatch<SetStateAction<boolean>>;
    descriptionTooltip: (text: string) => JSX.Element;
    currentRowData: any;
    getPTOPlans: any;
    setErrorMessage: Dispatch<SetStateAction<string>>;
    setShowErrorMessages: Dispatch<SetStateAction<boolean>>;
    ptoHourlyCalculationMethods: { id: number, title: string, description: string }[]
}

interface DetailsState {
    StartingMonth: number | null | string;
    StartingMonthValid: boolean;
    EndingMonth: number | null | string;
    AccrualAmount: number | null | string;
    AccrualAmountValid: boolean;
    MaxAccrualCeilingHours: number | null | string;
    HourlyAccrualAmount: number | null | string;
    PTOPlanId?: number | null;
    PTOPlanDetailId?: number | null;
    ModifiedBy?: number | null;
    CreatedBy?: number | null;
    DeletedBy?: number | null;
}
interface State {
    PTOPlanName: string;
    PTOPlanNameValid: boolean;
    Description: string;
    PlanPayType: string;
    MaxDailyPTOHours: number;
    AccrualWaitingPeriodDays: number;
    CarryOverMaxHours: number;
    UsingWaitingPeriodDays: number;
    PTOPlanId: number;
    PTOPlanDetails: DetailsState[];
    PayOutPercent: number | null | string;
    PTOHourlyCalculationMethodId: number | null | string

}
interface Action {
    type: string;
    payload: any;
    detail?: any;
}


// used with the reducer to eliminate potential typos as much as possible
const ACTIONS = {
    state: "state",
    PTOPlanName: 'PTOPlanName',
    Description: 'Description',
    PlanPayType: 'PlanPayType',
    MaxDailyPTOHours: 'MaxDailyPTOHours',
    AccrualWaitingPeriodDays: 'AccrualWaitingPeriodDays',
    CarryOverMaxHours: 'CarryOverMaxHours',
    UsingWaitingPeriodDays: 'UsingWaitingPeriodDays',
    StartingMonth: 'StartingMonth',
    EndingMonth: 'EndingMonth',
    AccrualAmount: 'AccrualAmount',
    MaxAccrualCeilingHours: 'MaxAccrualCeilingHours',
    HourlyAccrualAmount: 'HourlyAccrualAmount',
    PayOutPercent: 'PayOutPercent',
    AddPlanDetail: 'AddPlanDetail',
    DeletePlanDetail: 'DeletePlanDetail',
    PTOHourlyCalculationMethodId: 'PTOHourlyCalculationMethodId'
};

// Using the `ACTIONS` object with the switch case, this reducer changes the state object by calling `dispatch`.
// The dispatch has a `action.type` which is the case you are trying to get to, a `action.payload` which is the change that will take place,
//   and optionally a `action.detail` which is the index of the detail you are trying to affect.
// If case doesn't exist, it just returns the current state object.
const reducer = (state: State, action: Action): any => {
    const tempDetailsArray: DetailsState[] = state.PTOPlanDetails;
    let isValid: boolean;
    switch (action.type) {
        case ACTIONS.state:
            return { ...action.payload }
        case ACTIONS.PTOPlanName:
            isValid = action.payload.trim().length !== 0;
            return { ...state, PTOPlanName: action.payload, PTOPlanNameValid: isValid };
        case ACTIONS.Description:
            return { ...state, Description: action.payload };
        case ACTIONS.PlanPayType:
            return { ...state, PlanPayType: action.payload };
        case ACTIONS.MaxDailyPTOHours:
            if (action.payload === '') { return { ...state, MaxDailyPTOHours: '' }; }
            return { ...state, MaxDailyPTOHours: Number(action.payload) };
        case ACTIONS.AccrualWaitingPeriodDays:
            if (action.payload === '') { return { ...state, AccrualWaitingPeriodDays: '' }; }
            return { ...state, AccrualWaitingPeriodDays: Number(action.payload) };
        case ACTIONS.CarryOverMaxHours:
            if (action.payload === '') { return { ...state, CarryOverMaxHours: '' }; }
            return { ...state, CarryOverMaxHours: Number(action.payload) };
        case ACTIONS.UsingWaitingPeriodDays:
            if (action.payload === '') { return { ...state, UsingWaitingPeriodDays: '' }; }
            return { ...state, UsingWaitingPeriodDays: Number(action.payload) };
        case ACTIONS.PTOHourlyCalculationMethodId:
            if (action.payload === '') { return { ...state, PTOHourlyCalculationMethodId: '' }; }
            return { ...state, PTOHourlyCalculationMethodId: action.payload ? Number(action.payload) : null };
        case ACTIONS.PayOutPercent:
            if (action.payload === '') { return { ...state, PayOutPercent: '' }; }
            return { ...state, PayOutPercent: Number(action.payload) };
        case ACTIONS.StartingMonth:
            if (action.payload === '') {
                tempDetailsArray[action.detail].StartingMonth = '';
                tempDetailsArray[action.detail].StartingMonthValid = false;
            } else {
                tempDetailsArray[action.detail].StartingMonth = Number(action.payload);
                tempDetailsArray[action.detail].StartingMonthValid = true;
            }
            if (tempDetailsArray[action.detail].CreatedBy !== 0) { tempDetailsArray[action.detail].ModifiedBy = 0; } // set this to 0 so the backend knows this detail has been changed
            return { ...state, PTOPlanDetails: tempDetailsArray };
        case ACTIONS.EndingMonth:
            if (action.payload === '') {
                tempDetailsArray[action.detail].EndingMonth = '';
            } else {
                tempDetailsArray[action.detail].EndingMonth = Number(action.payload);
            }
            tempDetailsArray[action.detail].ModifiedBy = 0; // set this to 0 so the backend knows this detail has been changed
            return { ...state, PTOPlanDetails: tempDetailsArray };
        case ACTIONS.AccrualAmount:
            if (action.payload === '') {
                tempDetailsArray[action.detail].AccrualAmount = '';
                tempDetailsArray[action.detail].AccrualAmountValid = false;
            } else {
                tempDetailsArray[action.detail].AccrualAmount = Number(action.payload);
                tempDetailsArray[action.detail].AccrualAmountValid = true;
            }
            tempDetailsArray[action.detail].ModifiedBy = 0; // set this to 0 so the backend knows this detail has been changed
            return { ...state, PTOPlanDetails: tempDetailsArray };
        case ACTIONS.MaxAccrualCeilingHours:
            if (action.payload === '') {
                tempDetailsArray[action.detail].MaxAccrualCeilingHours = '';
            } else {
                tempDetailsArray[action.detail].MaxAccrualCeilingHours = Number(action.payload);
            }
            tempDetailsArray[action.detail].ModifiedBy = 0; // set this to 0 so the backend knows this detail has been changed
            return { ...state, PTOPlanDetails: tempDetailsArray };
        case ACTIONS.HourlyAccrualAmount:
            if (action.payload === '') {
                tempDetailsArray[action.detail].HourlyAccrualAmount = '';
            } else {
                tempDetailsArray[action.detail].HourlyAccrualAmount = Number(action.payload);
            }
            tempDetailsArray[action.detail].ModifiedBy = 0; // set this to 0 so the backend knows this detail has been changed
            return { ...state, PTOPlanDetails: tempDetailsArray };
        case ACTIONS.AddPlanDetail:
            const newPlanDetail: DetailsState = { StartingMonth: null, StartingMonthValid: false, EndingMonth: null, HourlyAccrualAmount: null, AccrualAmount: null, AccrualAmountValid: false, MaxAccrualCeilingHours: null, CreatedBy: 0 };
            tempDetailsArray.push(newPlanDetail);
            return { ...state, PTOPlanDetails: tempDetailsArray };
        case ACTIONS.DeletePlanDetail:
            if (tempDetailsArray[action.detail]?.CreatedBy === 0) {     // if created during this render, remove the detail from the array
                tempDetailsArray.splice(action.detail, 1);
            } else {    // if it already existed, add `DeletedBy` property and set it to 0
                tempDetailsArray[action.detail].DeletedBy = action.payload;
            }
            return { ...state, PTOPlanDetails: tempDetailsArray };
        default:
            return { ...state };
    };
};

const PTOPlanModal: React.FC<IProps> = (props: IProps) => {

    const { showModal, setShowModal, descriptionTooltip, currentRowData, getPTOPlans, setErrorMessage, setShowErrorMessages } = props;

    const [showDeletePrompt, setShowDeletePrompt] = useState(false as boolean);
    const [tableCoordinates, setTableCoordinates] = useState<Coordinates>();
    const [loadingResponse, setLoadingResponse] = useState(false);
    const [showAddPlanTypePopover, setShowAddPlanTypePopover] = useState(false);
    const [showAddPlanTypeTooltip, setShowAddPlanTypeTooltip] = useState(false);
    const [planPayTypes, setPlanPayTypes] = useState<string[]>([]);
    const [addedPlanPayTypes, setAddedPlanPayTypes] = useState<string[]>([]);
    const [newPlanType, setNewPlanType] = useState<string | null>();
    const [submitClicked, setSubmitClicked] = useState(false);
    const [isPlanValid, setIsPlanValid] = useState(true);
    const [planHasChanged, setPlanHasChanged] = useState(false);
    const [deletingPlan, setDeletingPlan] = useState(false);
    const [planActiveEmployees, setPlanActiveEmployees] = useState<ActiveEmployee[]>();
    const [searchString, setSearchString] = useState<string>();
    const [showWarningModal, setShowWarningModal] = useState<boolean>(false)

    const modalTarget = useRef(null);
    const addPlanTypeTarget = useRef(null);

    interface PTOPlanDetailsSingleRow {
        StartingMonth: number;
        EndingMonth: number;
        AccrualAmount: number;
        MaxAccrualCeilingHours: number;
        HourlyAccrualAmount: number | null
        PTOPlanId?: number | null;
        PTOPlanDetailId?: number | null;
        CreatedBy?: number | null;
        ModifiedBy?: number | null;
        DeletedBy?: number | null;
    };
    interface planData {
        PTOPlanName: string;
        Description: string;
        PlanPayType: string;
        MaxDailyPTOHours: number;
        AccrualWaitingPeriodDays: number;
        UsingWaitingPeriodDays: number;
        CarryOverMaxHours: number;
        PTOPlanId: number | null;
        DeletedBy?: number | null;
        ModifiedBy?: number;
        PTOHourlyCalculationMethodId: number | null
        PayOutPercent: number | string | null
        PTOPlanDetails: PTOPlanDetailsSingleRow[];
    };
    interface singleColumnPlanDetails {
        columnKey: string;
        columnName: string;
        order: number
        precision: number

    };
    interface Coordinates {
        x: number | null;
        y: number | null;
    };
    interface PlanPayType {
        PlanPayTypeName: string;
    };
    interface ActiveEmployee {
        firstName: string;
        lastName: string;
    };

    // initializing the state object using either the current row data coming from the table, or blank data if adding a new plan
    const initialState: State = {
        PTOPlanName: currentRowData ? currentRowData.PTOPlanName : '',
        PTOPlanNameValid: currentRowData ? true : false,
        Description: currentRowData ? currentRowData.Description : '',
        PlanPayType: currentRowData ? currentRowData.PlanPayType : '',
        MaxDailyPTOHours: currentRowData ? currentRowData.MaxDailyPTOHours : '',
        AccrualWaitingPeriodDays: currentRowData ? currentRowData.AccrualWaitingPeriodDays : '',
        CarryOverMaxHours: currentRowData ? currentRowData.CarryOverMaxHours : '',
        UsingWaitingPeriodDays: currentRowData ? currentRowData.UsingWaitingPeriodDays : '',
        PTOPlanId: currentRowData ? currentRowData.PTOPlanId : 0,
        PTOHourlyCalculationMethodId: currentRowData ? currentRowData.PTOHourlyCalculationMethodId : 0,
        PayOutPercent: currentRowData ? currentRowData.PayOutPercent : '',
        PTOPlanDetails: currentRowData ?
            JSON.parse(JSON.stringify(currentRowData.PTOPlanDetails)) :  // doing this stringify/parse so that when the plan details get updated, it doesn't update the `currentRowData` object
            [{ StartingMonth: '', EndingMonth: '', AccrualAmount: '', MaxAccrualCeilingHours: '', PTOPlanId: '', PTOPlanDetailId: '', PayOutPercent: '', HourlyAccrualAmount: '' }]
    }
    // adds the `valid` properties to the details object
    initialState.PTOPlanDetails.forEach((detail) => {
        detail.StartingMonthValid = currentRowData ? true : false;
        detail.AccrualAmountValid = currentRowData ? true : false;
    });
    const [state, dispatch] = useReducer(reducer, initialState);

    const hideKeys = ['Salary']

    const showHourlyStuff = !hideKeys.includes(state.PlanPayType);

    const columns: singleColumnPlanDetails[] = [
        { columnKey: 'StartingMonth', columnName: 'Starting Month', order: 1, precision: 0 },//int
        { columnKey: 'EndingMonth', columnName: 'Ending Month', order: 2, precision: 0 },//int
        { columnKey: 'AccrualAmount', columnName: 'Max Accrual Amount', order: 4, precision: 3 },//decimal(7,3)
        { columnKey: 'MaxAccrualCeilingHours', columnName: 'Max Accrual Ceiling Hours', order: 6, precision: 0 },//int
        // Include conditionally:
        ...(showHourlyStuff ? [{ columnKey: 'HourlyAccrualAmount', columnName: 'Hourly Accrual Amount', order: 3, precision: 4 }] : []),//decimal(8,4)
    ].sort(({ order: a }, { order: b }) => a - b);

    const getPTOPlanPayTypes = () => {
        Axios.get(`${process.env.REACT_APP_API_URL}/api/pto/planpaytypes`, AxiosConfig.configValue())
            // Axios.get(`http://localhost:3001/api/pto/planpaytypes`, AxiosConfig.configValue())
            .then(response => {
                if (!response.data.Error.success) { setErrorMessage('There was an error getting the plan pay types.'); setShowErrorMessages(true); }
                if (!response.data.planPayTypes) { if (state.PlanPayType !== '') setPlanPayTypes([state.PlanPayType]); }

                const tempPlanPayTypes: string[] = [];
                //r-18-lint-id
                //eslint-disable-next-line
                response.data.planPayTypes.map((type: any) => {
                    tempPlanPayTypes.push(type.PlanPayTypeName);
                });
                setPlanPayTypes(tempPlanPayTypes);
            }).catch(error => {
                setErrorMessage('There was an error getting the plan pay types.');
                setShowErrorMessages(true);
                if (state.PlanPayType !== '') setPlanPayTypes([state.PlanPayType])
            }).finally(() => { });
    };

    const getActiveEmployees = () => {
        Axios.get(`${process.env.REACT_APP_API_URL}/api/pto/planactiveemployee/${state.PTOPlanId}`, AxiosConfig.configValue())
            // Axios.get(`http://localhost:3001/api/pto/planactiveemployee/${state.PTOPlanId}`, AxiosConfig.configValue())
            .then(response => {
                if (!response.data.Error.success) {
                    setErrorMessage('There was an error getting this plans active employee\'s');
                    setShowErrorMessages(true);
                    return;
                }

                const tempPlanActiveEmployees: ActiveEmployee[] = [];
                response.data.response.forEach((employee: any) => {
                    const tempEmployee: ActiveEmployee = {
                        firstName: employee.FirstName,
                        lastName: employee.LastName
                    }
                    tempPlanActiveEmployees.push(tempEmployee);
                });
                setPlanActiveEmployees(tempPlanActiveEmployees);
            }).catch(error => {
                setErrorMessage('There was an error getting this plans active employee\'s');
                setShowErrorMessages(true);
            }).finally(() => { });
    };

    const addPTOPlanPayType = async (type: PlanPayType) => {
        let error = false;
        const backendResponseError = await Axios.post(`${process.env.REACT_APP_API_URL}/api/pto/planpaytypes`,
            // const backendResponseError = await Axios.post(`http://localhost:3001/api/pto/planpaytypes`,
            type,
            AxiosConfig.configValue('min'))
            .then(response => {
                if (!response.data.Error.success) { setErrorMessage('There was an error adding the plan type.'); setShowErrorMessages(true); error = true; }
                return error;
            }).catch(error => {
                setErrorMessage('There was an error adding the plan type.');
                setShowErrorMessages(true);
                return error;
            }).finally(() => { });
        return backendResponseError;
    };

    const cleanUpHourlyIfSalary = (plan: planData) => {

        if (!showHourlyStuff) {
            let cleanedPlan = { ...plan }
            for (let i = 0; i < plan.PTOPlanDetails.length; i++) {
                let cd = cleanedPlan.PTOPlanDetails[i]
                cd.HourlyAccrualAmount = null
            }
            return cleanedPlan
        }

        return plan
    }

    const addPTOPlan = async (newPlan: planData) => {
        await validatePlan(state);
        if (!isPlanValid) return;

        // checks if the selected Plan Pay Type is new, and if so calls backend to add to cooresponding table
        if (addedPlanPayTypes.includes(newPlan.PlanPayType)) {
            const resultError = await addPTOPlanPayType({ PlanPayTypeName: newPlan.PlanPayType });
            // if error occured while adding plan type, set state.PlanPayType to empty string and recall getPTOPlanPayTypes so dropdown is current, then return so plan isn't added. 
            if (resultError) {
                dispatch({ type: ACTIONS.PlanPayType, payload: '' });
                getPTOPlanPayTypes();
                return;
            }
        }

        setLoadingResponse(true);
        Axios.post(`${process.env.REACT_APP_API_URL}/api/pto/plans`,
            // Axios.post(`http://localhost:3001/api/pto/plans`,
            cleanUpHourlyIfSalary(newPlan),
            AxiosConfig.configValue('min'))
            .then(response => {
                if (!response.data.Error.success) { setErrorMessage('There was an error adding the plan.'); setShowErrorMessages(true); }
            }).catch(error => {
                setErrorMessage('There was an error adding the plan.');
                setShowErrorMessages(true);
            }).finally(() => {
                getPTOPlans();
                setShowModal(false);
                setLoadingResponse(false);
            });
    };

    const editPTOPlan = async (plan: planData) => {
        await validatePlan(state);
        if (!isPlanValid) return;

        // checks if the selected Plan Pay Type is new, and if so calls backend to add to cooresponding table
        if (addedPlanPayTypes.includes(plan.PlanPayType)) {
            const resultError = await addPTOPlanPayType({ PlanPayTypeName: plan.PlanPayType });
            // if there was an error adding plan pay type, set state.PlanPayType to empty string and retrieve exisitng plan pay types from backend, then return so plan table isn't modified
            if (resultError) {
                dispatch({ type: ACTIONS.PlanPayType, payload: '' });
                getPTOPlanPayTypes();
                return;
            }
        }

        // if at least one plan field has been changed, set `ModifiedBy = 0` so the backend knows the plan was updated
        if (plan.PTOPlanName !== currentRowData.PTOPlanName) { plan.ModifiedBy = 0; }
        else if (plan.PlanPayType !== currentRowData.PlanPayType) { plan.ModifiedBy = 0; }
        else if (plan.Description !== currentRowData.Description) { plan.ModifiedBy = 0; }
        else if (plan.MaxDailyPTOHours !== currentRowData.MaxDailyPTOHours) { plan.ModifiedBy = 0; }
        else if (plan.AccrualWaitingPeriodDays !== currentRowData.AccrualWaitingPeriodDays) { plan.ModifiedBy = 0; }
        else if (plan.CarryOverMaxHours !== currentRowData.CarryOverMaxHours) { plan.ModifiedBy = 0; }
        else if (plan.UsingWaitingPeriodDays !== currentRowData.UsingWaitingPeriodDays) { plan.ModifiedBy = 0; }
        else if (plan.PTOHourlyCalculationMethodId !== currentRowData.PTOHourlyCalculationMethodId) { plan.ModifiedBy = 0; }
        else if (plan.PayOutPercent !== currentRowData.PayOutPercent) { plan.ModifiedBy = 0; }


        setLoadingResponse(true);
        Axios.post(`${process.env.REACT_APP_API_URL}/api/pto/plans`,
            // Axios.post(`http://localhost:3001/api/pto/plans`,
            cleanUpHourlyIfSalary(plan),
            AxiosConfig.configValue('min'))
            .then(response => {
                if (!response.data.Error.success) { setErrorMessage(response.data.Error.message); setShowErrorMessages(true); }
            }).catch(error => {
                setErrorMessage('There was an error editing/deleting the plan.');
                setShowErrorMessages(true);
            }).finally(() => {
                getPTOPlans();
                setShowDeletePrompt(false);
                setShowModal(false);
                setLoadingResponse(false);
            });
    };

    const renderDescriptionPopover = () => (
        <Popover id='description-popover'>
            <Popover.Content>
                <strong>Max Daily PTO:</strong>
                <p>Maximum number of PTO hours per request per day.</p>
                <strong>Carry Over Max Hours:</strong>
                <p>Maximum PTO hours that can be carried over at year end.</p>
                <strong>Accrual Waiting Period Days:</strong>
                <p>Number of days before accruals occur.</p>
                <strong>Using Waiting Period Days:</strong>
                <p>Number of days before employee can use PTO.</p>
                <strong>Max Accrual Ceiling Hours:</strong>
                <p>Total number of PTO hours that can accrue during the year.</p>
            </Popover.Content>
        </Popover>
    );

    const renderPopoverAddPlanType = () => {
        return (
            <Popover id='add-plan-type-popover'>
                <Popover.Title as='h3'>Add Plan Pay Type</Popover.Title>
                <Popover.Content>
                    <Form.Control autoFocus type='text' className='PTOPlanMaintenanceSingleInput' onKeyPress={(event: KeyboardEvent<HTMLInputElement>) => { if (event.key === 'Enter') handleAddPlanType() }} onChange={(event: ChangeEvent<HTMLInputElement>) => setNewPlanType(event.target.value)} maxLength={40} />
                    <Button variant='primary' size='sm' block disabled={newPlanType === null || newPlanType === ''} onClick={() => handleAddPlanType()}>Add Plan Type</Button>
                </Popover.Content>
            </Popover>
        );
    };

    const renderSaveButton = () => {
        if (currentRowData) {
            return (
                <Button variant='primary' disabled={loadingResponse || (submitClicked && !isPlanValid) || !planHasChanged} onClick={() => { editPTOPlan(state); setSubmitClicked(true); }}>
                    {loadingResponse ? 'Saving...' : 'Save Changes'}
                </Button>
            );
        } else {
            return (
                <Button variant='primary' disabled={loadingResponse || (submitClicked && !isPlanValid)} onClick={() => { addPTOPlan(state); setSubmitClicked(true); }}>
                    {loadingResponse ? 'Adding...' : 'Add Plan'}
                </Button>
            );
        }
    };

    const formatDecimal = (value: string, precision: number) => {
        if (isNaN(parseFloat(value))) {
            return ''
        }
        if (precision === 0) {
            return Math.round(Number(value)).toString();
        }
        const regex = new RegExp(`^-?\\d+(?:\\.\\d{0,${precision}})?`);
        const match = value.match(regex);
        return match ? match[0] : '';
    };

    // Builds the plan details table with data for the current plan
    const renderPlanDetailsTable = () => {
        return (
            <div className='PTOPlanMaintenanceModalContentWrapper'>
                <Table id="d23a375c344f1ba035cb93117e90e" striped bordered hover>
                    <thead>
                        <tr>
                            {columns.map((col, i) => (
                                <th key={i}>{col.columnName}</th>
                            ))}
                        </tr>
                    </thead>
                    <tfoot>
                        <tr>
                            <th>
                                <OverlayTrigger overlay={descriptionTooltip('Add Plan Detail')}>
                                    <span className='material-icons af926f1a998144f1a9e828278ffda032' onClick={() => dispatch({ type: ACTIONS.AddPlanDetail, payload: '' })}>add</span>
                                </OverlayTrigger>
                            </th>
                        </tr>
                    </tfoot>
                    <tbody>
                        {/*r-18-lint-id*/}
                        {/*eslint-disable-next-line*/}
                        {state.PTOPlanDetails.map((row: any, rowIndex: number) => {
                            //r-18-lint-id
                            //eslint-disable-next-line
                            if (row.DeletedBy === 0) { return; }
                            return (
                                <tr>
                                    {columns.map((col, colIndex) => {
                                        const haaDisabled = showHourlyStuff && col.columnKey === "HourlyAccrualAmount" && state.PTOHourlyCalculationMethodId === 1
                                        if (tableCoordinates && tableCoordinates.x === colIndex && tableCoordinates.y === rowIndex) {
                                            return (
                                                <td>

                                                    {haaDisabled &&
                                                        <div>
                                                            *NA*
                                                        </div>}

                                                    {!haaDisabled && <Form.Control
                                                        type='number'
                                                        className='PTOPlanMaintenanceNumberInput'
                                                        onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => {
                                                            const forbiddenChars = ['e', 'E', '+', '-'];

                                                            if (col.precision === 0) {
                                                                forbiddenChars.push('.');
                                                            }

                                                            if (forbiddenChars.includes(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                        autoFocus={true}
                                                        onBlur={() => setTableCoordinates({ x: null, y: null })}
                                                        value={row[col.columnKey as keyof any]}
                                                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                                            const formattedValue = formatDecimal(event.target.value, col.precision);
                                                            dispatch({ type: ACTIONS[col.columnKey as keyof typeof ACTIONS], payload: formattedValue, detail: rowIndex })
                                                        }}
                                                    // disabled={haaDisabled}
                                                    />}

                                                </td>
                                            );
                                        }
                                        return (
                                            <>
                                                <td onClick={() => setTableCoordinates({ x: colIndex, y: rowIndex })} >
                                                    {!haaDisabled && <>
                                                        {row[col.columnKey as keyof any]}
                                                        {((col.columnKey === 'StartingMonth' && !row.StartingMonthValid && submitClicked) || (col.columnKey === 'AccrualAmount' && !row.AccrualAmountValid && submitClicked)) && (
                                                            <span className='material-icons PTOPlanMaintenanceIconError'>error_outline</span>
                                                        )}

                                                        {(col.columnKey === 'HourlyAccrualAmount' && state.PTOHourlyCalculationMethodId === 2 && (!row[col.columnKey as keyof any] || row[col.columnKey as keyof any] === "") && submitClicked) &&
                                                            <span className='material-icons PTOPlanMaintenanceIconError'>error_outline</span>
                                                        }
                                                    </>}
                                                    {haaDisabled &&
                                                        <div>
                                                            *NA*
                                                        </div>}
                                                </td>
                                            </>
                                        );
                                    })}
                                    <td>
                                        <OverlayTrigger overlay={descriptionTooltip('Delete Row')}>
                                            <span className='material-icons-outlined' onClick={() => { if (state.PTOPlanDetails.filter((detail: any) => detail.DeletedBy !== 0).length > 1) dispatch({ type: ACTIONS.DeletePlanDetail, payload: 0, detail: rowIndex }) }}>delete</span>
                                        </OverlayTrigger>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        );
    };

    // render active employee
    const renderActiveEmployeeTable = () => {
        return (
            <div className='PTOPlanMaintenanceModalContentWrapper'>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {planActiveEmployees?.map((employee) => {
                            if (handleSearchActiveEmployee(employee)) {
                                return (
                                    <tr>
                                        <td>{employee.firstName}</td>
                                        <td>{employee.lastName}</td>
                                    </tr>
                                )
                            }
                        })}
                    </tbody>
                </Table>
            </div>
        );
    };

    const hasValuesForHourlyAccrual = (plan: State) => {
        for (let i = 0; i < plan.PTOPlanDetails.length; i++) {
            const d = plan.PTOPlanDetails[i]
            if (!d.HourlyAccrualAmount) {
                return false
            }
        }
        return plan.PTOPlanDetails.length > 0 ? true : false
    }

    // validate plan inputs
    const validatePlan = (plan: State) => {
        let invalidCount = 0;

        if (!plan.PTOPlanNameValid) invalidCount++; // checks that plan name is valid
        if (!plan.PlanPayType) invalidCount++;
        if (plan.PTOPlanDetails.length <= 0) invalidCount++;    // checks that there is at least one plan detail
        if (plan.PTOHourlyCalculationMethodId === 2 && !hasValuesForHourlyAccrual(plan)) invalidCount++
        if (showHourlyStuff && !plan.PTOHourlyCalculationMethodId) invalidCount++
        if ((plan.PTOPlanDetails.filter((details) => details.DeletedBy === 0).length === plan.PTOPlanDetails.length)) invalidCount++; // checks that at least one plan detail isn't soft deleted
        plan.PTOPlanDetails.forEach((details) => {
            if (details.DeletedBy !== 0) {  // only checks details that haven't been soft deleted
                if (!details.StartingMonthValid) invalidCount++;    // checks that starting month is valid
                if (!details.AccrualAmountValid) invalidCount++;    // checks that accrual amount is valid
            }
        });

        if (invalidCount === 0) setIsPlanValid(true);
        else setIsPlanValid(false);
    };

    // checks if any fields in the plan have changed from the original
    const compareValues = (state: State) => {
        if (!currentRowData) return;    // if there is no current row data, there is no need to compare values as there is no original, so just return.
        let hasChangedCount = 0;

        if (currentRowData.PTOPlanName !== state.PTOPlanName) hasChangedCount++;
        if (currentRowData.Description !== state.Description) hasChangedCount++;
        if (currentRowData.PlanPayType !== state.PlanPayType) hasChangedCount++;
        if (currentRowData.MaxDailyPTOHours !== state.MaxDailyPTOHours) hasChangedCount++;
        if (currentRowData.AccrualWaitingPeriodDays !== state.AccrualWaitingPeriodDays) hasChangedCount++;
        if (currentRowData.CarryOverMaxHours !== state.CarryOverMaxHours) hasChangedCount++;
        if (currentRowData.UsingWaitingPeriodDays !== state.UsingWaitingPeriodDays) hasChangedCount++;
        if (currentRowData.PTOHourlyCalculationMethodId !== state.PTOHourlyCalculationMethodId) hasChangedCount++;
        if (currentRowData.PayOutPercent !== state.PayOutPercent) hasChangedCount++;

        if (state.PTOPlanDetails.filter((details) => details.DeletedBy === 0).length !== 0) hasChangedCount++;
        if (state.PTOPlanDetails.filter((details) => details.CreatedBy === 0).length !== 0) hasChangedCount++;
        if ((state.PTOPlanDetails.filter((details) => details.DeletedBy === 0).length === 0) && state.PTOPlanDetails.filter((details) => details.CreatedBy === 0).length === 0) {
            state.PTOPlanDetails.forEach((details, index) => {
                if (currentRowData.PTOPlanDetails[index].StartingMonth !== details.StartingMonth) hasChangedCount++;
                if (currentRowData.PTOPlanDetails[index].EndingMonth !== details.EndingMonth) hasChangedCount++;
                if (currentRowData.PTOPlanDetails[index].AccrualAmount !== details.AccrualAmount) hasChangedCount++;
                if (currentRowData.PTOPlanDetails[index].MaxAccrualCeilingHours !== details.MaxAccrualCeilingHours) hasChangedCount++;
                if (currentRowData.PTOPlanDetails[index].HourlyAccrualAmount !== details.HourlyAccrualAmount) hasChangedCount++;
            });
        }

        if (hasChangedCount === 0 && planHasChanged) setPlanHasChanged(false);  // only sets plan has changed to false if it isn't already false and the plan is the same as original
        if (hasChangedCount > 0 && !planHasChanged) setPlanHasChanged(true);    // only sets plan has changed to true if it isn't already true and the plan is different from the original
    };

    // adds a deletedBy of 0 to the current plan to tell the backend to soft delete it
    const handlePlanDelete = (plan: planData) => {
        setDeletingPlan(true);
        plan.DeletedBy = 0;
        editPTOPlan(plan);
    };

    // if a new type has been added, this adds it to the dropdown array and to the added plan types array
    const handleAddPlanType = () => {
        // checks for white space or if string exists in different casings
        let typeAlreadyExists = false;
        planPayTypes.forEach((type: string) => {
            if (type.trim().toLowerCase() === newPlanType?.trim().toLowerCase()) {
                typeAlreadyExists = true;
                dispatch({ type: ACTIONS.PlanPayType, payload: type }); // if plan type already exists, this sets the state to that type
            }
        });
        if (typeof newPlanType === 'string' && newPlanType !== '' && !planPayTypes.includes(newPlanType) && !typeAlreadyExists) {
            setPlanPayTypes([...planPayTypes, newPlanType]);
            setAddedPlanPayTypes([...addedPlanPayTypes, newPlanType]);
            dispatch({ type: ACTIONS.PlanPayType, payload: newPlanType });  // if this is a new plan type, this sets the state to the new type
        }
        setShowAddPlanTypePopover(false);
    };

    const handleClearSearch = () => {
        if (!searchString || searchString.length === 0) return;
        setSearchString('');
    };

    const handleSearchActiveEmployee = (row: ActiveEmployee) => {
        if (!searchString || searchString.length === 0) return true;
        if (row.lastName && row.lastName.trim().toLowerCase().includes(searchString.trim().toLowerCase())) return true;
        if (row.firstName && row.firstName.trim().toLowerCase().includes(searchString.trim().toLowerCase())) return true;
        return false;
    };

    const getPtoHourlyCalculationMethod = () => {
        const phcms = props.ptoHourlyCalculationMethods;
        const selectedMethod = phcms.find(phcm => state.PTOHourlyCalculationMethodId === phcm.id);
        return selectedMethod ? { value: selectedMethod.id, label: reggie.deCamel(selectedMethod.title) } : null;
    };

    const handleDiscard = (discard: boolean) => {
        if (discard) {
            let newState: planData = state
            newState.PTOHourlyCalculationMethodId = null
            newState.PlanPayType = "Salary"
            for (let i = 0; i < newState.PTOPlanDetails.length; i++) {
                let detail = newState.PTOPlanDetails[i]
                detail.HourlyAccrualAmount = null
                detail.ModifiedBy = 0
            }
            dispatch({ type: ACTIONS.state, payload: newState })
            setShowWarningModal(false)
        } else {
            setShowWarningModal(false)
        }
    }

    useEffect(() => {
        getPTOPlanPayTypes();
        if (currentRowData) { getActiveEmployees(); }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        validatePlan(state);
        compareValues(state);
        //eslint-disable-next-line
    }, [state]);

    useEffect(() => {
        if (showAddPlanTypePopover) {
            setNewPlanType(null);
        }
    }, [showAddPlanTypePopover]);


    // console.log('PTOPlanModal props', props)
    // console.log('PTOPlanModal state', state)

    const PTOHourlyCalculationMethodPopover = () => (
        <Popover id={"dd485d0575034404aae74137fda4dd3c"}>
            <Popover.Title>
                <div className="PTOHourlyCalculationMethodPopoverTitle">
                    <p>PTO Hourly Calculation Methods</p>
                </div>
            </Popover.Title>
            <Popover.Content>
                <div className="PTOHourlyCalculationMethodPopoverContent">
                    {props.ptoHourlyCalculationMethods.map((m, i) =>
                        <div key={i} className={`TOHourlyCalculationMethodPopoverContentItem ${state.PTOHourlyCalculationMethodId === m.id ? "PTOHourlyCalculationMethodPopoverContentItemSelected" : "TOHourlyCalculationMethodPopoverContentItemNotSelected"}`}>
                            <div className='PTOHourlyCalculationMethodPopoverContentItemTitle'>
                                <FormControl
                                    checked={state.PTOHourlyCalculationMethodId === m.id}
                                    onChange={() => null}
                                    type="checkbox"
                                />
                                <p>{reggie.deCamel(m.title)}</p>
                            </div>
                            <div className='PTOHourlyCalculationMethodPopoverContentItemDescription'>
                                <p>{m.description}</p>
                            </div>
                        </div>
                    )}
                </div>
            </Popover.Content>
        </Popover>
    )

    return (
        <div>
            {showWarningModal && <PTOPlanMaintenanceWarnLostChanges handleDiscard={handleDiscard} />}
            <Modal id={`${showWarningModal ? "f44bd454cb891a2574027ac905d" : "efc65bb4b2e9c989719d0f70ad6"}`} show={showModal} centered size='xl'>
                <Modal.Header className='PTOPlanMaintenanceModalHeader'>
                    <p>{currentRowData ? `Edit: ${currentRowData.PTOPlanName}` : "Add a new PTO Plan"}</p>
                    <OverlayTrigger placement='right' overlay={renderDescriptionPopover()}>
                        <span className='material-icons e4da817ac436b868d5593acf41a89'>info</span>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body ref={modalTarget}>
                    <Form className='PTOPlanMaintenanceModalSection'>
                        <div className='PTOPlanMaintenanceModalContainer'>
                            <div className='PTOPlanMaintenanceModalContainerLeftUpper'>
                                <div className='PTOPlanMaintenanceModalContainerLeftUpperLeft'>
                                    <div className='PTOPlanMaintenanceModalInputWrapper'>
                                        <div className='PTOPlanMaintenanceModalInputTitle'>Plan Name</div>
                                        <Form.Control id='dd524645ace1ae13c1402323' isInvalid={!state.PTOPlanNameValid && submitClicked} className='PTOPlanMaintenanceNameInput' value={state.PTOPlanName} onChange={(event: ChangeEvent<HTMLInputElement>) => dispatch({ type: ACTIONS.PTOPlanName, payload: event.target.value })} maxLength={250} />
                                    </div>
                                </div>
                                <div className='PTOPlanMaintenanceModalContainerLeftUpperRight'>
                                    <div className='PTOPlanMaintenanceModalInputWrapper'>
                                        <div className='c0d9ff69dacd4efcba4a35ba6cf32ee2'>
                                            <div className='PTOPlanMaintenanceModalInputTitle'>Plan Type</div>
                                            {(!state.PlanPayType || state.PlanPayType === '') && submitClicked && (
                                                <span className='material-icons PTOPlanMaintenanceIconError'>error_outline</span>
                                            )}
                                        </div>
                                        <div className='de9653ca2e84ac884c0cd2e3ae9c5b7'>
                                            <Select
                                                id="a6a7dfc35f41008606745a25f951cb"
                                                placeholder={"..."}
                                                value={{ value: state.PlanPayType, label: state.PlanPayType }}
                                                options={planPayTypes.map((pt) => ({ value: pt, label: pt }))}
                                                onChange={(selectedItem: { value: number, label: string } | null) => {
                                                    if (showHourlyStuff && selectedItem?.label === "Salary") {
                                                        setShowWarningModal(true)
                                                    } else {
                                                        dispatch({ type: ACTIONS.PlanPayType, payload: selectedItem?.value })
                                                    }
                                                }}
                                            />
                                            <span ref={addPlanTypeTarget} onMouseOver={() => setShowAddPlanTypeTooltip(true)} onMouseLeave={() => setShowAddPlanTypeTooltip(false)} onClick={() => setShowAddPlanTypePopover(true)} className='material-icons af926f1a998144f1a9e828278ffda032 fd3b9f3d8bc4c9f843c2e1575f7f0f7'>add</span>
                                            <Overlay placement='right' container={modalTarget} target={addPlanTypeTarget.current} show={showAddPlanTypePopover || showAddPlanTypeTooltip} rootClose rootCloseEvent='click' onHide={() => setShowAddPlanTypePopover(false)}>
                                                {showAddPlanTypePopover ? renderPopoverAddPlanType() : descriptionTooltip('Add Plan Type')}
                                            </Overlay>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='PTOPlanMaintenanceModalInputWrapper'>
                                <div className='PTOPlanMaintenanceModalInputTitle'>Description</div>
                                <Form.Control className='PTOPlanMaintenanceTextArea' as='textarea' value={state.Description} onChange={(event: ChangeEvent<HTMLInputElement>) => dispatch({ type: ACTIONS.Description, payload: event.target.value })} rows={3} maxLength={500} />
                            </div>
                        </div>
                        <div className='PTOPlanMaintenanceModalContainer'>
                            <div className='d6792cb7841c7a61d1a13ee996afe'>
                                <div className='PTOPlanMaintenanceModalInputWrapper'>
                                    <div className='PTOPlanMaintenanceModalInputTitle'>Max Daily PTO Hours</div>
                                    <Form.Control className='PTOPlanMaintenanceNumberInput' type='number' onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-', '.'].includes(event.key) && event.preventDefault()} value={state.MaxDailyPTOHours} onChange={(event: ChangeEvent<HTMLInputElement>) => dispatch({ type: ACTIONS.MaxDailyPTOHours, payload: event.target.value })} />
                                    <div className='PTOPlanMaintenanceModalInputTitle'>Accrual Waiting Period Days</div>
                                    <Form.Control className='PTOPlanMaintenanceNumberInput' type='number' onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-', '.'].includes(event.key) && event.preventDefault()} value={state.AccrualWaitingPeriodDays} onChange={(event: ChangeEvent<HTMLInputElement>) => dispatch({ type: ACTIONS.AccrualWaitingPeriodDays, payload: event.target.value })} />
                                </div>
                                <div className='PTOPlanMaintenanceModalInputWrapper'>
                                    <div className='PTOPlanMaintenanceModalInputTitle'>Carry Over Max Hours</div>
                                    <Form.Control className='PTOPlanMaintenanceNumberInput' type='number' onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-', '.'].includes(event.key) && event.preventDefault()} value={state.CarryOverMaxHours} onChange={(event: ChangeEvent<HTMLInputElement>) => dispatch({ type: ACTIONS.CarryOverMaxHours, payload: event.target.value })} />
                                    <div className='PTOPlanMaintenanceModalInputTitle'>Using Waiting Period Days</div>
                                    <Form.Control className='PTOPlanMaintenanceNumberInput' type='number' onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-', '.'].includes(event.key) && event.preventDefault()} value={state.UsingWaitingPeriodDays} onChange={(event: ChangeEvent<HTMLInputElement>) => dispatch({ type: ACTIONS.UsingWaitingPeriodDays, payload: event.target.value })} />

                                </div>
                                <div className='PTOPlanMaintenanceModalInputWrapper'>
                                    <div className='PTOPlanMaintenanceModalInputTitle'>PTO Payout Percent</div>
                                    <Form.Control className='PTOPlanMaintenanceNumberInput' type='number' onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-', '.'].includes(event.key) && event.preventDefault()} value={state.PayOutPercent} onChange={(event: ChangeEvent<HTMLInputElement>) => dispatch({ type: ACTIONS.PayOutPercent, payload: event.target.value })} />
                                </div>
                            </div>

                        </div>
                    </Form>
                    <hr className='PTOPlanMaintenanceDivider'></hr>
                    <div className='PTOPlanMaintenanceModalSection PTOPlanMaintenanceModalSectionBottom'>
                        <div id='d47a9f8ba41559e66b812b6f61e4d' className='PTOPlanMaintenanceModalContainer'>
                            <div className='PTOPlanMaintenanceModalContainerHeader'>
                                <div className='PTOPlanMaintenanceModalContainerHeaderLeft'>
                                    <div className='f4a2d1047f8a95bc28c96dff337'>Plan Details</div>
                                </div>
                                <div className='PTOPlanMaintenanceModalContainerHeaderRight'>
                                    {showHourlyStuff && submitClicked && !state.PTOHourlyCalculationMethodId &&
                                        <span id='e51aa224aaeab2253c2ce2308bb' className='material-icons PTOPlanMaintenanceIconError'>error_outline</span>
                                    }
                                    {showHourlyStuff &&
                                        <Select
                                            id="f117123eba4440bf6865d23025a8a1"
                                            placeholder={"Hourly Calculation Method"}
                                            value={getPtoHourlyCalculationMethod()}
                                            options={props.ptoHourlyCalculationMethods.map((phcm) => ({ value: phcm.id, label: reggie.deCamel(phcm.title) }))}
                                            onChange={(selectedItem: { value: number, label: string } | null) => {

                                                if (selectedItem?.value === 1) {
                                                    let newState = { ...state }
                                                    newState.PTOHourlyCalculationMethodId = selectedItem.value
                                                    for (let i = 0; i < state.PTOPlanDetails.length; i++) {
                                                        let cd = newState.PTOPlanDetails[i]
                                                        cd.HourlyAccrualAmount = null
                                                        cd.ModifiedBy = 0
                                                    }
                                                    dispatch({ type: ACTIONS.state, payload: newState })
                                                } else {
                                                    dispatch({ type: ACTIONS.PTOHourlyCalculationMethodId, payload: selectedItem ? selectedItem.value : null })
                                                }
                                            }}
                                            isClearable
                                        />}
                                    {showHourlyStuff && <OverlayTrigger
                                        placement="left"
                                        overlay={PTOHourlyCalculationMethodPopover()}
                                    >
                                        <span id='c5a61cba5c274e32b5d483267944570e' className='material-icons'>info</span>
                                    </OverlayTrigger>}
                                </div>
                            </div>
                            {renderPlanDetailsTable()}
                        </div>
                        {currentRowData && (
                            <div className='PTOPlanMaintenanceModalContainer'>
                                <div className='PTOPlanMaintenanceActiveEmployeeHeaderWrapper'>
                                    <div className='f4a2d1047f8a95bc28c96dff337'>Plan Active Employees</div>
                                    <div className='PTOPlanMaintenanceActiveEmployeeSearch'>
                                        <Button variant='secondary' className='d1941c2b4f1d80517afde995421f' size='sm' onClick={() => handleClearSearch()}>
                                            <span className='material-icons-outlined'>{(searchString && searchString.length > 0) ? 'close' : 'search'}</span>
                                        </Button>
                                        <Form.Control placeholder='Search' value={searchString || ''} onChange={(event: ChangeEvent<HTMLInputElement>) => setSearchString(event.target.value)} />
                                    </div>
                                </div>
                                {renderActiveEmployeeTable()}
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {!showDeletePrompt && (
                        <>
                            {renderSaveButton()}
                            {currentRowData && (
                                <Button variant='danger' disabled={loadingResponse} onClick={() => setShowDeletePrompt(true)}>Delete Plan</Button>
                            )}
                            <Button variant='secondary' disabled={loadingResponse} onClick={() => setShowModal(false)}>Cancel</Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
            <Modal show={showDeletePrompt} centered>
                <Modal.Body>
                    <Alert show={showDeletePrompt} variant='danger' transition={false}>
                        <Alert.Heading>Are you sure you want to delete this plan?</Alert.Heading>
                        <Button variant='outline-danger' className='PTOPlanMaintenanceButtonMargin' disabled={deletingPlan} onClick={() => handlePlanDelete(state)}>Delete</Button>
                        <Button variant='secondary' className='PTOPlanMaintenanceButtonMargin' disabled={deletingPlan} onClick={() => setShowDeletePrompt(false)}>Cancel</Button>
                    </Alert>
                </Modal.Body>
            </Modal>
        </div>
    );
}

const mapStateToProps = (state: AppState) => ({
    ptoHourlyCalculationMethods: state.userReference.userReference.ptoHourlyCalculationMethods ? state.userReference.userReference.ptoHourlyCalculationMethods : []
})

export default connect(mapStateToProps)(PTOPlanModal)